import appConfig from '../../../appConfig';

export const defaultFormData = {
	invite_code: 'WELCOME',
	email: '',
	password: '',
	first_name: '',
	last_name: '',
	birth_date: '',
	phone: '',
	country: appConfig.regions.isUS ? 'US' : 'AU',
	unit_number: '',
	street_number: '',
	street_name: '',
	street_type: '',
	city: '',
	state: '',
	postcode: '',
	set_deposit_limit: undefined,
	deposit_limit: {
		limit: 0,
		duration_type_id: '',
	},
	enable2fa:false,
	isManualAddress:false,
	opted_in:false
};
